import React from 'react';
import { IssuerContext } from '../contexts';

export const useIssuer = () => React.useContext(IssuerContext);
